export enum TableEllipsisPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
  BOTH = 'both'
}
